import axios from "axios";

const admin = JSON.parse(localStorage.getItem("ADMIN"));
if (admin) {
  axios.defaults.headers.common["x-access-token"] = admin.token;
}
axios.defaults.headers.common["platform"] = "AdminWeb";

const authHeaders = () => {
  const currentAdmin = JSON.parse(localStorage.getItem("ADMIN"));
  return currentAdmin?.token
    ? { "x-access-token": currentAdmin.token }
    : undefined;
};

export default {
  FitnessApi(url = `${process.env.REACT_APP_BASE_URL}/api/v1/fitness`) {
    return {
      createTrainer: (data) =>
        axios.post(`${url}/admin/trainers/create`, data, {
          headers: authHeaders(),
        }),

      updateTrainer: (trainerId, data) =>
        axios.put(`${url}/admin/trainers/${trainerId}`, data, {
          headers: authHeaders(),
        }),

      listTrainers: (params = {}) =>
        axios.get(`${url}/admin/trainers`, {
          params,
          headers: authHeaders(),
        }),

      getWorkingHours: (params = {}) =>
        axios.get(`${url}/admin/trainers/working-hours`, {
          params,
          headers: authHeaders(),
        }),

      setWorkingHours: (data) =>
        axios.post(`${url}/admin/trainers/working-hours`, data, {
          headers: authHeaders(),
        }),

      addCustomSlots: (data) =>
        axios.post(`${url}/admin/trainers/custom-slots`, data, {
          headers: authHeaders(),
        }),

      blockSlots: (data) =>
        axios.post(`${url}/admin/trainers/block-slots`, data, {
          headers: authHeaders(),
        }),

      adminBookSession: (data) =>
        axios.post(`${url}/admin/session/book`, data, {
          headers: authHeaders(),
        }),

      listSessions: (params = {}) =>
        axios.get(`${url}/admin/sessions`, {
          params,
          headers: authHeaders(),
        }),

      checkLearnerStatus: (data) =>
        axios.post(`${url}/learner/check-status`, data),

      availableSlots: (data) =>
        axios.post(`${url}/slots/available`, data),

      cancelSession: (data) =>
        axios.post(`${url}/session/cancel`, data, {
          headers: authHeaders(),
        }),

      rescheduleSession: (data) =>
        axios.post(`${url}/session/reschedule`, data, {
          headers: authHeaders(),
        }),
    };
  },
};
